import {
  ModalBody as ModalBodyPrimitive,
  type ModalBodyProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function ModalBody({ children, ...props }: ModalBodyProps): ReactNode {
  return (
    <ModalBodyPrimitive py="4" px="6" {...props}>
      {children}
    </ModalBodyPrimitive>
  );
}
